module.exports = __webpack_public_path__ + "static/media/empty-folder.07568cae.svg";